import type { ReactNode } from "react";
import { TopBar } from "./TopBar";
import { BottomNav } from "./BottomNav";
import { Sidebar } from "./Sidebar";

export function AppLayout({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <div className="flex min-h-screen bg-slate50">
      {/* Sidebar — visible on lg+ */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex flex-1 flex-col">
        <TopBar title={title} />
        <main className="mx-auto w-full max-w-6xl flex-1 px-4 pb-24 pt-4 sm:px-6 lg:pb-8 lg:pt-6">
          {children}
        </main>
        {/* Bottom nav — visible only on mobile */}
        <div className="lg:hidden">
          <BottomNav />
        </div>
      </div>
    </div>
  );
}
